module.exports = __webpack_public_path__ + "img/mobile-bottom.fc9000f9.webp";